
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "./pages/AdminLogin";
import MainLayout from "./pages/MainLayout";
import Templates from "./pages/Templates";
import UserManagement from "./pages/UserManagement";
import AthleticConf from "./pages/AthleticConf";
import States from "./pages/States";
import Schools from "./pages/Schools";
import SchoolStatus from "./pages/SchoolStatus";
import SchoolProfile from "./pages/SchoolProfile";
import SchoolContacts from "./pages/SchoolContacts";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUserManagement from "./pages/AdminUserManagement";
import AcceptInvite from "./pages/AcceptInvite";
import HistoricalWinners from "./pages/HistoricalWinners";
import YOYParticipation from "./pages/YOYParticipation";
import UpdateAccount from "./pages/UpdateAccount";
import Winners from "./pages/Winners";

function App() {
  const [loginSuccess, setLoginSuccess] = React.useState(false);
  const token = typeof window !== 'undefined' ? localStorage.getItem("token") : null;
  const path = typeof window !== 'undefined' && window.location && window.location.pathname ? window.location.pathname : '';
  const isPublicAuthPath = path.startsWith('/accept-invite') || path.startsWith('/forgot-password') || path.startsWith('/historical-winners');
  if (loginSuccess || token || isPublicAuthPath) {
    return (
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<AdminDashboard />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/school-contacts" element={<SchoolContacts />} />
            <Route path="/school-status" element={<SchoolStatus />} />
            <Route path="/admin/schools/:id" element={<SchoolProfile />} />
            <Route path="/schools/:id" element={<SchoolProfile />} />
            <Route path="/athletic-conferences" element={<AthleticConf />} />
            <Route path="/states" element={<States />} />
            <Route path="/schools" element={<Schools />} />
            <Route path="/historical-winners" element={<HistoricalWinners />} />
            <Route path="/yoy-participation" element={<YOYParticipation />} />
            <Route path="/winners/:year" element={<Winners />} />
            <Route path="/admin-users" element={<AdminUserManagement />} />
            <Route path="/account" element={<UpdateAccount />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
          </Routes>
        </MainLayout>
      </Router>
    );
  }
  return <AdminLogin onLogin={() => setLoginSuccess(true)} />;
}
export default App;
